import React, { useState, useEffect, useRef, useContext } from "react";
import { useQuery, gql, useMutation, useLazyQuery } from "@apollo/client";
import { Query } from "react-apollo";
// import {  ApolloProvider } from '@apollo/client';
import Loader from "react-loader-spinner";
import { client } from "../../services/GraphqlService.js";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Container, Row, Col } from "react-bootstrap";
import roomImg from "../../assets/room-img.svg";
import warning from "../../assets/warning.svg";
import "./Rooms.scss";
import { useHistory } from "react-router-dom";
import Messages from "../Messages/Messages";
import { dateDifference } from "../../helpers/Utils";
import { MyContext } from "../Dashboard/Dashboard.js";
import useNetwork from "../../customHooks/useNetwork";
import db from "../../DexieDBConfig.js";
import { Tooltip } from "primereact/tooltip";
import { encryptHybrid } from "../InputField/encryptHybrid.js";
import { getKey } from "./dataService.js";
import { useLocation } from "react-router-dom";

const ADD_SENSOR = gql`
  mutation saveVirtualSensorValue(
    $vesselId: ID!
    $sensorInput: [VirtualSensorInput!]
  ) {
    saveVirtualSensorValue(vesselId: $vesselId, sensorInput: $sensorInput)
  }
`;

let formdetails = false;

const Rooms = (props) => {
  const networkState = useNetwork();
  const { online } = networkState;

  let { setBgColor, selectedCustomer, getCustMetaData } = useContext(MyContext);
  let updateUnsbmittedData = [];
  const [voyageRoomId, setVoyageRoomId] = useState();
  const [allUnsubmitted, setUnSubmitted] = useState([]);
  const [allsubmitted, setSubmitted] = useState([]);
  const [isOnline, setNetwork] = useState(window.navigator.onLine);
  const [queryCompleted, setQueryCompleted] = useState(true);
  const [syncPending, setSyncPending] = useState(false);
  const [todayDate, setDate] = useState(moment().format("L"));
  const [count, setCount] = useState(0);
  const [roomID, setRoomId] = useState(null);
  const [wait, setWait] = useState(false);
  const [roomErrors, setRoomErrors] = useState({});
  const [pbKey, setKey] = useState(null);
  const [keyFetching, setKeyFetching] = useState(false);
  const [classSociety, setClassSociety] = useState(undefined);
  const [bvRoom, setBvRoom] = useState(undefined);
  const [dailyRound, setDailyRound] = useState(undefined);
  let unsubmittedComment = [
    {
      vesselId: null,
      roomId: null,
      customerId: null,
      valueId: null,
      value: null,
      UTCtimeStamp: null,
    },
  ];

  const {
    match: { params },
  } = props;

  const { vid, cid, rid } = params;
  const location = useLocation();
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const mrvEnabled = searchParams.get("mrvEnabled");
    const classSocietyParam = searchParams.get("classSociety");
    const dailyRound = searchParams.get("dailyRound");

    if (mrvEnabled !== null) {
      setBvRoom(mrvEnabled === "true");
    }
    if (classSocietyParam !== null) {
      setClassSociety(classSocietyParam);
    }
    if (dailyRound !== null) {
      setDailyRound(dailyRound === "true");
    }
  }, [location.search]);

  useEffect(() => {
    if (
      bvRoom !== undefined &&
      classSociety !== undefined &&
      dailyRound !== undefined
    ) {
      getRoomData();
    }
  }, [bvRoom, classSociety, dailyRound]);

  let history = useHistory();

  const VALIDATION_ERRORS = gql`
    query mrvValidationErrorSensors(
      $vesselId: ID!
      $customerId: ID!
      $startTime: Float
      $endTime: Float
      $docType: String!
    ) {
      mrvValidationErrorSensors(
        vesselId: $vesselId
        customerId: $customerId
        startTime: $startTime
        endTime: $endTime
        docType: $docType
      )
    }
  `;

  const ROOMS_QUERY = gql`
    query roomsByVessel(
      $vid: ID!
      $cid: ID!
      $isMrvEnabled: Boolean!
      $classSociety: String
    ) {
      roomsByVessel(
        id: $vid
        id1: $cid
        isMrvEnabled: $isMrvEnabled
        classSociety: $classSociety
      ) {
        name
        id
        customerId
      }
    }
  `;
  const Rooms_query_mix = gql`
    query {
      roomsByVessel(id:${vid},id1:${cid}, isMrvEnabled:true, classSociety:"${classSociety}")
        {
          name,
          id,
          customerId
        }
      }`;
  const [roomsList, setRoomsList] = useState();
  const [getRooms, { loading, error, data }] = useLazyQuery(ROOMS_QUERY, {
    fetchPolicy: "cache-and-network",
    onCompleted(resp) {
      if (bvRoom && dailyRound) {
        setWait(true);
        getRoomsMix();
      }
      if (bvRoom) {
        let mrvRoomz = JSON.parse(
          JSON.stringify(
            resp.roomsByVessel.filter(
              (room) => room.name.indexOf("Voyage sailing") == -1
            )
          )
        );
        let updatedResp = {
          roomsByVessel: mrvRoomz,
        };
        setRoomsList(updatedResp);
      } else {
        setRoomsList(resp);
      }
    },
  });

  const [getValidationErrors, { loadingErrors, errorErrors, dataErrors }] =
    useLazyQuery(VALIDATION_ERRORS, {
      fetchPolicy: "cache-and-network",
      onCompleted(resp) {
        let existingErrors = {};
        db.validationErrors.get(vid).then((results) => {
          // if (results) {
          //   existingErrors = results.data;
          // }
          // if (Object.keys(existingErrors).length > 0) {
          //   vars.sensorInput.map((each) => {
          //     if (existingErrors[each.roomId]) {
          //       let roomId = existingErrors[each.roomId];
          //       let timestamp = each.time;
          //       if (roomId[timestamp]) {
          //         delete existingErrors[each.roomId][timestamp];
          //         if (Object.keys(existingErrors[each.roomId]).length == 0) {
          //           delete existingErrors[each.roomId];
          //         }
          //       }
          //     }
          //   });
          // }
          let incomingErrors = resp.mrvValidationErrorSensors;

          let updatedErrors = mergeErrorMessages(
            existingErrors,
            incomingErrors
          );
          db.validationErrors.put({
            id: vid, // Generate a unique ID (e.g., timestamp)
            data: updatedErrors,
          });
          if (Object.keys(updatedErrors).length > 0) {
            toast.error(
              "There are some validation errors! Please fix them and resync."
            );
          }
          let genericErrors = resp.genericError ? resp.genericError : [];
          genericErrors.map((error) => {
            if (
              error ==
              "No data has been passed in the Logabstract Array Object. The first array should contain header information, followed by subsequent data arrays."
            ) {
              toast.error(
                "Please ensure that you have entered voyage departure/arrival data before syncing.",
                { autoClose: 8000 }
              );
            } else {
              toast.error(error, { autoClose: 8000 });
            }
          });
          db.validationErrors.get(vid).then((results) => {
            setRoomErrors(results.data);
          });
        });
      },
    });

  const [getRoomsMix, { loadingMix, errorMix, dataMix }] = useLazyQuery(
    Rooms_query_mix,
    {
      fetchPolicy: "cache-and-network",
      onCompleted(resp) {
        let voyageRoom = JSON.parse(
          JSON.stringify(
            resp.roomsByVessel.filter(
              (room) => room.name.indexOf("Voyage sailing") !== -1
            )
          )
        );
        voyageRoom[0].name = "Daily Report";
        setVoyageRoomId(voyageRoom[0].id);
        let currentRooms = JSON.parse(JSON.stringify(roomsList));
        currentRooms.roomsByVessel.push(voyageRoom[0]);
        setRoomsList(currentRooms);
        setWait(false);
      },
      onError: (error) => {
        setWait(false);
      },
    }
  );
  let vesselName = localStorage.getItem("vesselName");
  let countApi = useRef(0);

  useEffect(async () => {
    // setClassSociety(localStorage.getItem("classSociety") || null);
  }, []);

  useEffect(async () => {
    // let mrvEnabled = localStorage.getItem("mrvRoomEnabled");
    // if (mrvEnabled == "true") {
    //   setBvRoom(true);
    // } else {
    //   setBvRoom(false);
    // }

    db.validationErrors.get(vid).then((results) => {
      if (Object.keys(results.data).length > 0) {
        setRoomErrors(results.data);
      }
    });
  }, [classSociety]);

  useEffect(() => {
    db.unsyncedOperations.toArray().then((unSubmitted) => {
      setUnSubmitted(unSubmitted);
    });
    db.submittedOperations.toArray().then((submitted) => {
      setSubmitted(submitted);
    });

    window.addEventListener("offline", updateNetwork);
    window.addEventListener("online", updateNetwork);
    return () => {
      window.removeEventListener("offline", updateNetwork);
      window.removeEventListener("online", updateNetwork);
    };
  }, [isOnline]);
  const updateNetwork = () => {
    setNetwork(window.navigator.onLine);
  };

  const getRoomData = async () => {
    if (online) {
      getCustMetaData(cid, "", false, vid);
      getRooms({
        variables: {
          vid,
          cid,
          isMrvEnabled: dailyRound ? false : bvRoom,
          classSociety: dailyRound ? null : classSociety,
        },
      });
      getValidationErrors({
        variables: {
          vesselId: vid,
          customerId: cid,
          startTime: null,
          endTime: null,
          docType: dailyRound
            ? "vessellogbook"
            : classSociety == "BV"
            ? "mrvbvlogbook"
            : "mrvlloydslogbook",
        },
      });

      if (online && pbKey == null) {
        try {
          setKeyFetching(true);
          const code = await getKey(vid);
          if (code) {
            setKeyFetching(false);
            setKey(code);
          }
        } catch (e) {
          setKeyFetching(false);
          console.log("Error fetching key", e);
          toast.error(
            "An error occured while fetching data. Signature capture might not work."
          );
        }
      }
    } else {
      db.userInfo.toArray().then((users) => {
        let theUser = localStorage.getItem("offline_user_email")
          ? localStorage.getItem("offline_user_email")
          : localStorage.getItem("user_email");
        users.map((user) => {
          if (user.email == theUser) {
            user.response.customersByUser.map((cust) => {
              if (cust.customerId == cid) {
                cust.vessels.map((vessel) => {
                  if (vessel.id == vid) {
                    let bvFilterRooms = [];
                    let normalRooms = [];
                    let mrvEnabled = bvRoom;
                    let voyageRoom = JSON.parse(
                      JSON.stringify(
                        vessel.rooms.filter(
                          (room) => room.name.indexOf("Voyage sailing") !== -1
                        )
                      )
                    );
                    voyageRoom[0].name = "Daily Report";
                    setVoyageRoomId(voyageRoom[0].id);
                    if (mrvEnabled == "true") {
                      bvFilterRooms = vessel.rooms.filter(
                        (room) =>
                          (room.docType == "mrvbvlogbook" ||
                            room.docType == "mrvlloydslogbook") &&
                          room.name.indexOf("Voyage sailing") == -1
                      );
                    } else {
                      normalRooms = vessel.rooms.filter((room) => {
                        if (
                          room.docType == "vessellogbook" ||
                          room.name.indexOf("Voyage sailing") !== -1
                        ) {
                          if (room.name.indexOf("Voyage sailing") !== -1) {
                            room.name = "Daily Report";
                          }
                          return room;
                        }
                      });
                    }
                    let data = {
                      roomsByVessel: bvRoom ? bvFilterRooms : normalRooms,
                    };
                    setRoomsList(data);
                    setQueryCompleted(true);
                  }
                });
              }
            });
          }
        });
      });
    }
  };
  useEffect(async () => {
    setBgColor("#224691");
    setCount(0);
  }, [online]);

  useEffect(() => {
    // check and delete older from  sync db
    monitorSyncDb();
  }, [todayDate]);

  useEffect(() => {
    // check wether this vessel has any sensor to sync
    checkSync();
  }, [allsubmitted, allUnsubmitted]);

  const monitorSyncDb = () => {
    db.syncedOperations.toArray().then((results) => {
      results.map((result) => {
        let sensorDate = result.valueId.split("-")[2];
        let diff = dateDifference(sensorDate, todayDate);
        if (diff >= 30) {
          db.syncedOperations.delete(result.valueId);
        }
      });
    });
  };

  const checkSync = () => {
    let needToSync = [...allsubmitted, ...allUnsubmitted];
    let enable = false;

    if (needToSync.length > 0) {
      let count = 0;
      needToSync.forEach((data) => {
        if (vid == data.valueId.split("-")[0]) {
          count++;
          setCount(count);
          enable = true;
          return false;
        } else {
          setCount(count);
          return false;
        }
      });
      setSyncPending(enable);
    } else {
      setSyncPending(false);
    }
  };

  const mergeErrorMessages = (existingErrors, newErrors) => {
    for (const roomId in newErrors) {
      if (!existingErrors[roomId]) {
        // If roomId doesn't exist, add the whole roomId object
        existingErrors[roomId] = newErrors[roomId];
      } else {
        // RoomId exists, iterate over timestamps
        const newTimestamps = newErrors[roomId];
        for (const timestamp in newTimestamps) {
          // Replace the timestamp if it already exists, or just add it
          existingErrors[roomId][timestamp] = newTimestamps[timestamp];
        }
      }
    }
    return existingErrors;
  };

  const [updateTodo, { loading: mutationLoading, error: mutationError }] =
    useMutation(ADD_SENSOR, {
      onCompleted(resp, { variables }) {
        let vars = JSON.parse(JSON.stringify(variables));

        let sensorValues = [];
        // let genericErrors = resp.saveVirtualSensorValue.genericError;
        // if (
        //   genericErrors.length == 0 &&
        //   Object.keys(resp.saveVirtualSensorValue.validationError).length == 0
        // ) {
        toast.dismiss();
        toast.success("Synced to Triton Successfully!");
        // }
        let existingErrors = {};
        db.validationErrors.get(vars.vesselId).then((results) => {
          if (results && results.data) {
            existingErrors = results.data;
          }
          if (Object.keys(existingErrors).length > 0) {
            vars.sensorInput.map((each) => {
              if (existingErrors[each.roomId]) {
                let roomId = existingErrors[each.roomId];
                let timestamp = each.time;
                if (roomId[timestamp]) {
                  delete existingErrors[each.roomId][timestamp];
                  if (Object.keys(existingErrors[each.roomId]).length == 0) {
                    delete existingErrors[each.roomId];
                  }
                }
              }
            });
            // Update the validationErrors db with the modified existingErrors
            db.validationErrors.put({
              id: vars.vesselId,
              data: existingErrors,
            });
          }
        });
        //   let incomingErrors = resp.saveVirtualSensorValue.validationError;

        //   let updatedErrors = mergeErrorMessages(
        //     existingErrors,
        //     incomingErrors
        //   );
        //   db.validationErrors.put({
        //     id: vars.vesselId, // Generate a unique ID (e.g., timestamp)
        //     data: updatedErrors,
        //   });
        //   if (Object.keys(updatedErrors).length > 0) {
        //     toast.error(
        //       "There are some validation errors! Please fix them and resync."
        //     );
        //   }
        // genericErrors.map((error) => {
        //   if (
        //     error ==
        //     "No data has been passed in the Logabstract Array Object. The first array should contain header information, followed by subsequent data arrays."
        //   ) {
        //     toast.error(
        //       "Please ensure that you have entered voyage departure/arrival data before syncing.",
        //       { autoClose: 8000 }
        //     );
        //   } else {
        //     toast.error(error, { autoClose: 8000 });
        //   }
        // });
        // db.validationErrors.get(vars.vesselId).then((results) => {
        //   setRoomErrors(results.data);
        // });
        // });

        db.syncedOperations.toArray().then((synced) => {
          // adding date to unsubmitted
          let localDate = moment().format("L");
          let utcTime = moment().utc().valueOf();
          let allUnsubmittedWithDate = allUnsubmitted.map((unSubmitted) => {
            utcTime = unSubmitted.UTCtimeStamp;
            return {
              value: unSubmitted.value,
              valueId: `${unSubmitted.valueId}-${localDate}`,
              UTCtimestamp: unSubmitted.UTCtimeStamp,
            };
          });
          sensorValues = [
            ...sensorValues,
            ...synced,
            ...allsubmitted,
            ...allUnsubmittedWithDate,
          ];
          sensorValues.forEach((value1, i) => {
            sensorValues.forEach((value2) => {
              if (value1.valueId === value2.valueId) {
                sensorValues[i].value = { ...value1.value, ...value2.value };
              }
            });
          });
          sensorValues.forEach((data, i) => {
            if (vid == data.valueId.split("-")[0]) {
              db.syncedOperations.put({ ...data }, data.valueId).then(
                (event) => {},
                (error) => {
                  console.log(error);
                }
              );
            }
          });

          db.unsyncedOperations.toArray().then((results) => {
            results.map((result) => {
              if (bvRoom && dailyRound == false) {
                if (
                  vid == result.valueId.split("-")[0] &&
                  result.type == "bv"
                ) {
                  db.unsyncedOperations.delete(result.valueId);
                }
              } else {
                if (
                  vid == result.valueId.split("-")[0] &&
                  (result.type !== "bv" ||
                    result.valueId.split("-")[1] == voyageRoomId)
                ) {
                  db.unsyncedOperations.delete(result.valueId);
                }
              }
            });
          });
          setSyncPending(false);
          
          getValidationErrors({
            variables: {
              vesselId: vid,
              customerId: cid,
              startTime: null,
              endTime: null,
              docType: bvRoom
                ? classSociety == "BV"
                  ? "mrvbvlogbook"
                  : "mrvlloydslogbook"
                : "vessellogbook",
            },
          });
        });
      },
      onError(error) {
        toast.dismiss();
        toast.error("Sync Failed!");
        setSyncPending(false);
      },
    });

  const goToSensor = (room) => {
    if (dailyRound && room.id == voyageRoomId) {
      // setBvRoom(true);
      history.push(
        `rooms/${room.id}/sensors?mrvEnabled=true&classSociety=${classSociety}&dailyRound=false`
      );
    } else {
      history.push(
        `rooms/${room.id}/sensors?mrvEnabled=${bvRoom}&classSociety=${classSociety}&dailyRound=${dailyRound}`
      );
    }
    setRoomId(room.id);
    localStorage.setItem("roomName", room.name);
  };

  const syncData = async () => {
    // adding date to unsubmitted
    let localDate = moment().format("L");
    let utcTime;
    let filteredUnsubmitted;
    if (bvRoom && dailyRound == false) {
      filteredUnsubmitted = allUnsubmitted.filter(
        (item) => item.type == "bv" && !isNaN(item.UTCtimeStamp)
      );
    } else {
      filteredUnsubmitted = allUnsubmitted.filter((item) => {
        let roomId = item.valueId.split("-")[1];
        return (
          (item.type !== "bv" || roomId == voyageRoomId) &&
          !isNaN(item.UTCtimeStamp)
        );
      });
    }
    let allUnsubmittedWithDate = filteredUnsubmitted.map((unSubmitted) => {
      utcTime = unSubmitted.UTCtimeStamp;
      return {
        value: unSubmitted.value,
        correctedSensors: unSubmitted.correctedSensors
          ? unSubmitted.correctedSensors
          : null,
        valueId: `${unSubmitted.valueId}-${localDate}`,
        UTCtimestamp: unSubmitted.UTCtimeStamp,
        correctedTime: unSubmitted.correctedTime,
        timeZoneOffset:
          unSubmitted.timeZoneOffset !== undefined
            ? unSubmitted.timeZoneOffset
            : -new Date().getTimezoneOffset(),
        docType:
          unSubmitted.type == "bv"
            ? unSubmitted.classSociety
              ? unSubmitted.classSociety
              : "mrvbvlogbook"
            : "vessellogbook",
        UID:
          unSubmitted.Uid == undefined || unSubmitted.Uid == "undefined"
            ? localStorage.getItem("user_uid")
            : unSubmitted.Uid,
        corelationId: unSubmitted.corelationId
          ? unSubmitted.corelationId
          : null,
      };
    });

    let sensors = [];
    allUnsubmittedWithDate.forEach((data) => {
      if (vid == data.valueId.split("-")[0]) {
        let roomSensors = {
          roomId: data.valueId.split("-")[1],
          sensors: [],
          correctedSensors: data.correctedSensors
            ? data.correctedSensors
            : null,
          time: data.UTCtimestamp,
          correctedTime: data.correctedTime,
          timeZoneOffset:
            data.timeZoneOffset !== undefined
              ? data.timeZoneOffset
              : -new Date().getTimezoneOffset(),
          uid: data.UID,
          docType: data.docType,
          corelationId: data.corelationId ? data.corelationId : null,
        };
        Object.keys(data.value).forEach((key) => {
          if (data.value[key].includes("c2tldGNoUGFk")) {
            // Encrypt using hybrid RSA + AES
            try {
              let dataURL = JSON.parse(data.value[key]).data;
              let message = JSON.parse(data.value[key]).message;
              const result = encryptHybrid(dataURL, pbKey, message);
              roomSensors.sensors.push({
                id: key,
                value: JSON.stringify(result),
              });
            } catch (e) {
              console.error("Encryption failed", error);
            }
          } else {
            roomSensors.sensors.push({
              id: key,
              value: data.value[key],
            });
          }
        });
        if (roomSensors.sensors.length > 0) {
          sensors.push(roomSensors);
        }
      }
    });
    // sync if user have network
    if (isOnline) {
      // taking all tracked(submitted) sensors to sync
      let trackedSensors = [];
      try {
        // trackedSensors = await getTrackedSensors();
        // taking all unSubmitted sensors to sync
        sensors.forEach((sensorItem) => {
          trackedSensors.push({
            time: sensorItem.time,
            correctedTime: sensorItem.correctedTime,
            timeZoneOffset:
              sensorItem.timeZoneOffset !== undefined
                ? sensorItem.timeZoneOffset
                : -new Date().getTimezoneOffset(),
            roomId: +sensorItem.roomId,
            sensors: sensorItem.sensors,
            correctedSensors: sensorItem.correctedSensors
              ? sensorItem.correctedSensors
              : null,
            uId: sensorItem.uid,
            docType: sensorItem.docType,
            correlationId: sensorItem.corelationId
              ? sensorItem.corelationId
              : null,
          });
        });
      } catch (error) {
        console.log("eerr", error);
      }

      try {
        // check any sensor values needs to be sync
        if (trackedSensors.length > 0) {
          await updateTodo({
            variables: {
              vesselId: vid,
              sensorInput: trackedSensors,
            },
          });
        } else {
          toast.dismiss();
          toast.warning("Nothing to Sync!");
        }
      } catch (e) {
        toast.dismiss();
        toast.error("Daily Round Not Submitted!");
      }
    }
  };

  const roomsQueryCompleted = () => {
    countApi.current++;
    if (data.roomsByVessel.length == countApi.current) {
      setQueryCompleted(true);
    }
  };

  return (
    <div className="customers">
      <h5>TRITON Reporter</h5>
      <div className="title">
        <h4 className="welcome">
          This is <strong>{vesselName}</strong>
        </h4>
        <p className="question">Select one of the following actions</p>
      </div>
      <div className="overflow">
        {data &&
          data.roomsByVessel &&
          data.roomsByVessel.length !== 0 &&
          !queryCompleted && (
            <div className="loader">
              {" "}
              <Loader
                type="TailSpin"
                color=" #2546B1"
                height={80}
                width={80}
                timeout={300000000000000}
              />{" "}
            </div>
          )}
        {mutationError && <Messages data={mutationError} />}
        {!!!mutationError && error && <Messages data={error} />}
        {loading && (
          <div className="loader">
            <Loader
              type="TailSpin"
              color=" #2546B1"
              height={80}
              width={80}
              timeout={300000000000000000}
            />
          </div>
        )}
        {roomsList &&
          roomsList.roomsByVessel &&
          roomsList.roomsByVessel.length === 0 &&
          !wait && <p>No rooms to list!</p>}
        {!isOnline && !!!roomsList && !loading && (
          <span className="msg-content">
            Content is not loading since app has gone offline..
          </span>
        )}
        <Container>
          <Row>
            {roomsList &&
              roomsList.roomsByVessel &&
              roomsList.roomsByVessel.map((room, index) => (
                <Col
                  xs={6}
                  key={room.id}
                  onClick={() => queryCompleted && goToSensor(room)}
                >
                  {
                    <div className="room-box">
                      <Container>
                        <Row className="room-row">
                          <Col xs={12}>
                            <div
                              className="sec-title sec-ellipsis"
                              title={room.name}
                            >
                              {room.name}
                            </div>
                            {/* <ProgressBar variant="success" /> */}
                            {/* <div className="status">0 of 4 completed</div> */}
                          </Col>
                        </Row>
                        <Row className="room-row">
                          <Col xs={6}>
                            {roomErrors[room.id] ? (
                              <div className="warn-img">
                                <img
                                  src={warning}
                                  alt="warning"
                                  tooltip="There are validation errors in this room."
                                />
                              </div>
                            ) : null}
                          </Col>
                          <Col xs={6}>
                            <div className="room-img">
                              <img src={roomImg} alt="room" />
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  }
                </Col>
              ))}
          </Row>
          {isOnline ? (
            <button
              className="sync-btn"
              onClick={syncData}
              disabled={!syncPending || keyFetching}
              style={{ backgroundColor: bvRoom && !dailyRound ? "#24D18B" : "#FF7C52" }}
            >
              {mutationLoading || keyFetching ? (
                <Loader
                  type="ThreeDots"
                  color="#fff"
                  height={50}
                  width={50}
                  timeout={3000000000000}
                />
              ) : (
                "Sync to Triton"
              )}
            </button>
          ) : (
            <span className="offline-span">
              Device is offline. {count} record(s) to sync
            </span>
          )}
        </Container>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
      />
    </div>
  );
};

export default Rooms;
